import { GridColDef } from '@mui/x-data-grid';
import { formatDate } from '@shared/commonFunctions';
import { dataGridCol } from '@shared/components/grid/common';
import { dateFormatWithTime } from '@shared/constants/formats';

export const outOfSyncDS: GridColDef[] = [
  dataGridCol('id', {
    minWidth: 200,
    headerName: 'Dealsheet Id'
  }),
  dataGridCol('dealId', { minWidth: 200 }),
  dataGridCol('customerName', { minWidth: 200 }),
  dataGridCol('fundedDate', {
    minWidth: 180,
    valueGetter: ({ value }) => formatDate(value, { format: dateFormatWithTime }),
    type: 'dateTime',
  }),
  dataGridCol('amount', {
    minWidth: 100,
  }),
  dataGridCol('createdDate', {
    minWidth: 180,
    valueGetter: ({ value }) => formatDate(value, { format: dateFormatWithTime }),
    type: 'dateTime',
  }),
  dataGridCol('isSyncedToAcumatica', {
    minWidth: 100,
  }),
].map((column) => ({ flex: 1, ...column }));

export const outOfSyncDSAdjustment: GridColDef[] = [
  dataGridCol('id', {
    minWidth: 150,
    headerName: 'Dealsheet Adjustment Id'
  }),
  dataGridCol('dealId', {
    minWidth: 150,
  }),
  dataGridCol('customerName', {
    minWidth: 250,
  }),
  dataGridCol('amountFinanced', {
    width: 125,
  }),
  dataGridCol('adjPayoff', {
    minWidth: 125,
  }),
  dataGridCol('totalAdjustment', {
    minWidth: 150,
  }),
  dataGridCol('createdDate', {
    minWidth: 200,
    valueGetter: ({ value }) => formatDate(value, { format: dateFormatWithTime }),
    type: 'dateTime',
  }),
  dataGridCol('isSyncedToAcumatica', {
    minWidth: 200,
  }),
].map((column) => ({ flex: 1, ...column }));
